import { simpleFetch } from './customFetch';

export const getDefaultCouponsPlan = () => (
  simpleFetch(
    '/contents/default-plan-per-coupon/default',
    {},
    process.env.REACT_APP_CONTENT_API,
  )
);
